<template>
  <div class="container mt-24 md:mt-6 md:min-h-screen">
    <div class="md:grid grid-cols-12 linear-gradient-gray px-3 md:px-0 pt-12 pb-12 md:pt-48 md:pb-44 rounded-[10px]">
      <div class="col-start-3 col-span-8">
        <div v-if="successShow">
          <AtomTitle class="mb-10 md:mb-16" as="h2" animation="rotation"> Сообщение <br />отправлено!</AtomTitle>
          <AtomTitle tag="h3" class="max-w-[500px]" class-name="-md:text-base " animation="rotation">
            В&nbsp;ближайшее время наш менеджер свяжется с&nbsp;вами.
          </AtomTitle>
        </div>
        <div v-else>
          <AtomTitle as="p" class="mb-10 md:mb-16" animation="rotation">
            УЗНАТЬ
            <br />БОЛЬШЕ
          </AtomTitle>
          <form class="white form-two-col" @submit.prevent="send">
            <div class="form-input">
              <MoleculeSelect
                v-model="payload.club"
                :error="submitted && error.club"
                :items="clubs"
                :initial-index="initialClub"
                placeholder="Выберите клуб"
                class="item-input mb-2"
                @input="validate('club')"
              />
              <MoleculeInputPhone
                :error="submitted && error.phone"
                :value="payload.phone"
                label="Телефон*"
                class="item-input mb-2"
                type="tel"
                theme="white"
                @onInput="onInputPhone"
                @blur="onInputPhone"
              />
              <MoleculeInputText
                v-model="payload.first_name"
                :error="submitted && error.first_name"
                label="Имя*"
                class="item-input mb-2"
                type="text"
                @blur="validate('first_name')"
                @input="validate('first_name')"
              />
              <MoleculeInputText v-model="payload.last_name" label="Фамилия" class="item-input mb-2" type="text" />
              <MoleculeInputText v-model="payload.email" label="Email" class="item-input mb-2" type="email" />
            </div>
            <div class="controls flex flex-col mt-10 md:gap-y-14 md:mt-14">
              <MoleculeRadio
                v-model="radio"
                class="md:mt-3"
                type="radio"
                :checked="radio"
                :error="submitted && error.radio"
                label="С&nbsp;<a class='underline-offset-2 underline' href='https://www.encorefitness.ru/privacy-policy' target='_blank'>политикой обработки персональных данных</a> ознакомлен. Согласен на&nbsp;<a class='underline-offset-2 underline' href='https://www.encorefitness.ru/uploads/Согласие_на_обработку_ПД_2025.pdf' target='_blank'>обработку моих персональных данных</a>."
                @input="error.radio = !radio"
              />
              <MoleculeRadio
                v-model="receiving_advertising"
                class="mt-4"
                type="radio"
                :checked="receiving_advertising"
                label="Согласен на&nbsp;<a class='underline-offset-2 underline' href='https://www.encorefitness.ru/uploads/Согласие_на_рекламу.pdf' target='_blank'> получение рекламных и/или информационных сообщений</a>."
              />
              <AtomButton :disabled="submitting" tag="button" type="submit" class="w-full md:w-auto mt-10 md:mt-0">
                ОТПРАВИТЬ
              </AtomButton>
            </div>
            <div v-if="errorShow" class="text-red text-center text-sm mt-5">Произошла ошибка. Попробуйте позже</div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoleculeSelect from '../../molecules/forms/MoleculeSelect'
import AtomButton from '../../atoms/AtomButton'
import AtomTitle from '../../atoms/builder/AtomTitle'
import MoleculeInputText from '../../molecules/forms/MoleculeInputText'
import MoleculeInputPhone from '../../molecules/forms/MoleculeInputPhone'
import MoleculeRadio from '../../molecules/forms/MoleculeRadio'
import { getClubGoalName } from '../../../utils/getClubAsYMGoalName'
import { getUtmList } from '@/utils/cookies'
import { sendLeadToCalltouch } from '@/utils/calltouch'

export default {
  name: 'TemplateForms',
  components: {
    AtomTitle,
    AtomButton,
    MoleculeInputText,
    MoleculeInputPhone,
    MoleculeRadio,
    MoleculeSelect,
  },
  props: ['context'],
  builder: {
    component: 'form-learn-more',
  },
  data: () => {
    return {
      successShow: false,
      errorShow: false,
      submitted: false,
      submitting: false,
      radio: false,
      receiving_advertising: false,
      payload: {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        club: null,
      },
      error: {
        first_name: null,
        phone: null,
        radio: null,
        club: null,
      },
    }
  },
  computed: {
    clubs() {
      return (this.$store.getters['modules/content/getClubsAsListForm'] || []).filter(c => {
        return this.context?.cityId ? this.context.cityId == c.cityId : true
      })
    },
    initialClub() {
      const index = this.clubs.findIndex(club => {
        return club.slug == this.context?.club?.slug
      })
      return index === -1 ? null : index
    },
  },
  methods: {
    send() {
      this.errorShow = false
      this.submitted = true
      if (!this.submitting && this.validateForm()) {
        this.submitting = true
        const phone = `+${this.payload.phone.replace(/[^0-9]/g, '')}`
        let visitorUid = 'unknown'
        try {
          visitorUid = window.AMOPIXEL.getVisitorUid()
        } catch (e) {}

        const utmList = getUtmList(this.$cookies)
        const payload = {
          ...this.payload,
          phone,
          receiving_advertising: this.receiving_advertising,
          club: this.payload.club.slug,
          visitor_uid: visitorUid,
          ...utmList,
        }

        let clientId = 0
        try {
          clientId = window?.yaCounter37069155?.getClientID?.() ?? this.$cookies?.get('_ym_uid') ?? 0
        } catch (error) {
          this.$sentry.captureException(error)
        }

        if (clientId) {
          payload.clientId = String(clientId)
        }

        let roistatVisit = 'nocookie'
        try {
          roistatVisit = this.$cookies?.get('roistat_visit') || 'nocookie'
        } catch (error) {
          this.$sentry.captureException(error)
        }

        payload.roistat_visit = String(roistatVisit)

        this.$axios
          .post(
            '/api/forms/learn',
            {
              data: payload,
            },
            { __component: 'FormLearnMore' },
          )
          .then(() => {
            this.successShow = true

            // Format payload for Mango Office
            if (window.mgo?.postForm) {
              const mangoPayload = {
                name: `${payload.first_name} ${payload.last_name}`.trim(),
                number: payload.phone,
                email: payload.email || '',
                customParam: payload.club,
                fid: 'узнать больше',
              }
              window.mgo.postForm(mangoPayload)
            }

            if (payload.club === 'encore_sochi') {
              sendLeadToCalltouch(
                {
                  fio: `${payload.first_name || ''} ${payload.last_name || ''}`.trim(),
                  phoneNumber: payload.phone,
                  email: payload.email || '',
                  subject: 'Узнать больше',
                },
                this.$config,
              )
            }

            this.sendReachGoal(getClubGoalName(payload.club))
            this.sendReachGoal('success-form-learn', { api: 'forms/learn', club: payload.club })
          })
          .catch(() => {
            this.errorShow = true
          })
          .finally(() => {
            this.submitting = false
          })
      }
    },
    validateForm() {
      Object.keys(this.payload).forEach(key => {
        this.validate(key)
      })
      this.error.radio = !this.radio
      return !Object.values(this.error).some(Boolean)
    },
    validate(key) {
      const textIsInvalid = v => !(v || '').trim()
      const schema = {
        first_name: textIsInvalid,
        phone: v => !v || v.length !== 16,
        club: v => !v,
      }
      if (key in this.error && schema[key]) {
        const value = this.payload[key]
        this.error[key] = schema[key](value)
      }
    },
    onInputPhone(value, objValidPhone) {
      this.payload.phone = value

      if (!this.payload.phone || !objValidPhone.isValid) this.error.phone = !objValidPhone.isValid
      else this.error.phone = false
    },
  },
}
</script>

<style lang="postcss" scoped>
@media (min-width: 960px) {
  .form-two-col {
    .form-input {
      display: grid;
      gap: 20px;
      grid-auto-flow: row dense;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto auto auto;
      grid-template-areas:
        '. .'
        '. .'
        'a1 a1';
      ::v-deep .item-input:last-child {
        grid-area: a1;
      }
    }
    .controls {
      @apply md:grid grid-cols-2 gap-5 mt-8;
    }
  }
}
</style>
